import { SideMenu } from "@volvo/vcdk-react/SideMenu";
import { SideMenuGroup } from "@volvo/vcdk-react/SideMenuGroup";
import { SideMenuItem } from "@volvo/vcdk-react/SideMenuItem";
import {useEffect} from "react"
import {Link, useLocation} from "react-router-dom"
import {appConfig} from "../Config"
import {setSelectedNavAction} from "../containers/App/appSlice"
import {ShowForPermission} from "../Permissions"
import {RootState} from "../rootReducer"
import {useAppDispatch, useAppSelector} from "../store"
const SideNavigation = ({triggerOpening, onLinkClick}: {triggerOpening: boolean; onLinkClick: any}) => {
    const roles = useAppSelector((state: RootState) => state.containers.users.roles)

    const appRoles = {
        permission: roles?.map(x => x.id) ?? [],
    }
    const adminRoles = {
        permission: [appConfig.globalAdminRoleId, appConfig.regionalAdminRoleId],
    }

    const location = useLocation()
    const dispatch = useAppDispatch()
    const selectedNav = useAppSelector((state: RootState) => state.application.selectedNav)

    const setNavItemSelected = (path: string) => {
        dispatch(setSelectedNavAction(path.toString()))
        onLinkClick()
    }

    useEffect(() => {
        dispatch(setSelectedNavAction(location.pathname))
    }, [])

    const rSNL = (to: string, text: string) => {
        return (
            <Link to={to}>
                <SideMenuItem
                    onClick={() => {
                        setNavItemSelected(to)
                    }}
                    active={selectedNav === to}
                >
                    {text}
                </SideMenuItem>
            </Link>
        )
    }

    return (
        <>
        <style>
        {`
          vcdk-side-menu.collapse::part(menu) {
            width: 0px;
          }
            vcdk-side-menu-item::part(menu-item) {
                padding-top: 3px;
                padding-bottom: 3px;
            }
        `}
        </style>
        <SideMenu collapse={!triggerOpening} className={!triggerOpening ? "collapse" : ""} mode="permanent" width="240px" style={{position: 'fixed',top:'108px', left :0 , height: 'calc(100vh - 108px)', zIndex: 1050}}>
            <ShowForPermission {...appRoles}>
                {rSNL("/", "Dashboard")}
                <SideMenuGroup text="Manage MOT" open>
                    {rSNL("/overview", "Overview")}
                    {rSNL("/planner", "Planner")}
                    {rSNL("/mot-bookings", "Bookings")}
                    {rSNL("/pass-rates-summary", "Pass Rates Summary")}
                    {rSNL("/pass-rates-details", "Pass Rates Details")}
                    {rSNL("/reports", "Reports")}
                    {rSNL("/mot", "MOT History")}
                    {rSNL("/activities", "Activities")}
                </SideMenuGroup>
            </ShowForPermission>
            <ShowForPermission {...appRoles}>
                <SideMenuGroup text="Settings" open>
                        {rSNL("/fees", "Test Packages")}
                        {rSNL("/custom-prices", "Custom Pricing")}
                        {rSNL("/test-stations", "Test Stations")}
                        {rSNL("/customers", "Customers")}
                        {rSNL("/vehicles", "Vehicles")}
                        {rSNL("/dvsa-schedules", "DVSA Schedules")}
                        {rSNL("/dvsa-fee", "DVSA Fee")}
                        {rSNL("/dvsa-tests", "DVSA Tests")}
                </SideMenuGroup>
                <ShowForPermission {...adminRoles}>
                    <SideMenuGroup text="Administration" open>
                        {rSNL("/regions-and-dealers", "Regions & Dealers")}
                        {rSNL("/users", "Users")}
                    </SideMenuGroup>
                </ShowForPermission>
            </ShowForPermission>
            <ShowForPermission {...adminRoles}>
                {rSNL("/access-policies", "Access Policies")}
            </ShowForPermission>
        </SideMenu>
        </>
    )
}

export default SideNavigation
